export default class Translator {
  static _translations = {};
  static _loaded = false;

  static setTranslations(dict) {
    this._translations = { ...(dict || {}) };
    this._loaded = true;
  }

  static addTranslations(dict) {
    this._translations = { ...this._translations, ...(dict || {}) };
    this._loaded = true;
  }

  static _autoload() {
    if (this._loaded || typeof document === 'undefined') {
      return;
    }

    const nodes = document.querySelectorAll('script[type="application/json"][data-aui-translations]');
    console.log(nodes);
    nodes.forEach((node) => {
      try {
        const dict = JSON.parse(node.textContent || '{}');
        this.addTranslations(dict);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[Translator] Failed to parse translations JSON', e, node);
      }
    });

    if (document.readyState !== 'loading') {
      this._loaded = true;
    }
  }

  static translate(string, params) {
    this._autoload();

    let result = Object.prototype.hasOwnProperty.call(this._translations, string)
        ? this._translations[string]
        : string;

    if (params) {
      Object.keys(params).forEach((key) => {
        result = result.split(`%${key}%`).join(String(params[key]));
      });
    }

    return result;
  }
}
